export default "__VITE_ASSET__7969b8dc__"